:host {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(var(--size-12), var(--size-96)));
  gap: var(--size-4);
  padding: var(--size-2);
  justify-content: center;
  align-items: start;
  justify-items: stretch;
}

.card {
  border: var(--size-px) solid var(--pos-border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--size-8);
  max-width: var(--size-96);
  background: var(--pos-card-background);
}
